export interface ISunatHistoryItem {
    id?: string;
    date: string;
    period: string;
    format: string;
    user: string;
    hasTxt: boolean;
    hasXlsx: boolean;
    tagFormatColor?: string;
}

export interface ISunatPreviewRow {
    fecha: string;
    doc: string;
    numDoc: string;
    producto: string;
    entradaCant: string | number;
    entradaCosto: string;
    salidaCant: string | number;
    salidaCosto: string;
    saldo: string;
}

export const SUNAT_REPORT_TTL = 'Exportaciones de Kardex SUNAT';

export interface IExportHistoryDto {
    exportDate: string;
    periodMonth: number;
    periodYear: number;
    isTxt: boolean;
    isXlsx: boolean;
    userId: number;
    businessId: number;
}

export interface ISunatPreviewRow {
  periodo: string;
  codigo_establecimiento: string;
  catalogo: string;
  tipo_existencia: string;
  codigo_producto: string;

  fecha_operacion: string; // "21/07/2024"

  tipo_documento: string;
  serie: string;
  numero: string;
  tipo_operacion: string;

  descripcion: string;
  unidad_medida: string;
  metodo_valuacion: string;

  cantidad_entrada: string;
  costo_unitario_entrada: string;
  costo_total_entrada: string;

  cantidad_salida: string;
  costo_unitario_salida: string;
  costo_total_salida: string;

  cantidad_saldo: string;
  costo_unitario_saldo: string;
  costo_total_saldo: string;

  estado: string;
}
